/* eslint-disable @typescript-eslint/naming-convention */
import type { Link as LinkProps1 } from '@ps/web-martech-cms-types';
import { Link } from '@ps/web-shared-components';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import { omit, pick } from 'lodash';
import React from 'react';

import useAuthenticatedContent from '../../hooks/useAuthenticatedContent';

import styles from './CMSLink.scss';

const linkProps = ['rel', 'target', 'track_id', 'url', 'title'];

const CMSLink: React.FC<React.PropsWithChildren<Partial<LinkProps1> & Partial<ClassNameProp>>> = ({
  children,
  className,
  logged_in_link,
  ...rest
}) => {
  const { rel, target, title, track_id, url } = useAuthenticatedContent<
    Omit<LinkProps1, 'logged_in_link'>
  >(pick(rest, linkProps), logged_in_link);

  return (
    <Link
      href={url}
      trackText={track_id}
      rel={url && rel ? rel : undefined}
      target={url ? target : undefined}
      className={classNames(className, styles.link)}
      {...omit(rest, linkProps)}
    >
      {children || title}
    </Link>
  );
};
export default CMSLink;
